/*export default {
    mounted(el, binding) {
      const toggleAttr = el.getAttribute('data-el-toggle');
      const toggleActiveAttr = el.getAttribute('data-el-toggle-active');
      const targetElement = document.querySelector(toggleAttr);
      const activeElement = document.querySelector(toggleActiveAttr);
  
      // Function to close all dropdowns
      const closeAllDropdowns = () => {
        const allVisibleDropdowns = document.querySelectorAll('.js-click-dropdown.-is-el-visible');
        allVisibleDropdowns.forEach(dropdown => dropdown.classList.remove('-is-el-visible'));
  
        const allActiveDropdowns = document.querySelectorAll('.-is-dd-active');
        allActiveDropdowns.forEach(activeDropdown => activeDropdown.classList.remove('-is-dd-active'));
      };
  
      // Event handler for toggle click
      const toggleHandler = (event) => {
        event.stopPropagation();
        closeAllDropdowns();
  
        if (targetElement) {
          targetElement.classList.toggle('-is-el-visible');
        }
        if (activeElement) {
          activeElement.classList.toggle('-is-dd-active');
        }
      };
  
      // Attach click event listener to the toggle element
      el.addEventListener('click', toggleHandler);
  
      // Handle clicks outside to close the dropdown
      const outsideClickHandler = (event) => {
        if (targetElement && !targetElement.contains(event.target) && !el.contains(event.target)) {
          closeAllDropdowns();
        }
      };
  
      document.addEventListener('click', outsideClickHandler);
  
      // Cleanup listeners on unmount
      el._cleanup = () => {
        el.removeEventListener('click', toggleHandler);
        document.removeEventListener('click', outsideClickHandler);
      };
    },
    unmounted(el) {
      // Remove event listeners when the element is destroyed
      if (el._cleanup) {
        el._cleanup();
      }
    },
  };
  */
  export default {
    mounted(el, binding) {
      const toggleAttr = el.getAttribute('data-el-toggle');
      const toggleActiveAttr = el.getAttribute('data-el-toggle-active');
      const targetElement = document.querySelector(toggleAttr);
      const activeElement = document.querySelector(toggleActiveAttr);
  
      // Function to close all dropdowns
      const closeAllDropdowns = () => {
        const allVisibleDropdowns = document.querySelectorAll('.js-click-dropdown.-is-el-visible');
        allVisibleDropdowns.forEach((dropdown) => dropdown.classList.remove('-is-el-visible'));
  
        const allActiveDropdowns = document.querySelectorAll('.-is-dd-active');
        allActiveDropdowns.forEach((activeDropdown) => activeDropdown.classList.remove('-is-dd-active'));
      };
  
      // Event handler for toggle click
      const toggleHandler = (event) => {
        event.stopPropagation();
  
        const isCurrentlyVisible = targetElement && targetElement.classList.contains('-is-el-visible');
  
        // Close all dropdowns first
        closeAllDropdowns();
  
        // Toggle the current dropdown only if it was not already visible
        if (!isCurrentlyVisible) {
          if (targetElement) {
            targetElement.classList.add('-is-el-visible');
          }
          if (activeElement) {
            activeElement.classList.add('-is-dd-active');
          }
        }
      };
  
      // Attach click event listener to the toggle element
      el.addEventListener('click', toggleHandler);
  
      // Handle clicks outside to close all dropdowns
      const outsideClickHandler = (event) => {
        if (
          targetElement &&
          !targetElement.contains(event.target) &&
          !el.contains(event.target)
        ) {
          closeAllDropdowns();
        }
      };
  
      document.addEventListener('click', outsideClickHandler);
  
      // Cleanup listeners on unmount
      el._cleanup = () => {
        el.removeEventListener('click', toggleHandler);
        document.removeEventListener('click', outsideClickHandler);
      };
    },
    unmounted(el) {
      // Remove event listeners when the element is destroyed
      if (el._cleanup) {
        el._cleanup();
      }
    },
  };
  